import { render, staticRenderFns } from "./HeaderSecSuc.vue?vue&type=template&id=6b7cf1e5&scoped=true&"
import script from "./HeaderSecSuc.vue?vue&type=script&lang=js&"
export * from "./HeaderSecSuc.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSecSuc.vue?vue&type=style&index=0&id=6b7cf1e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7cf1e5",
  null
  
)

export default component.exports